import { capitalize } from "lodash"

export const PRINT = "Print"
export const EXPORT = "Export"

export const EXPORT_IMAGE = "Export Image"
export const EXPORT_PDF = "Export PDF"
export const EXPORT_DATA = "Export data"
export const PRINT_CHART = "Print Chart"
export const COPY_CHART_LINK = "Copy Chart Link"

export const BACKGROUND_COLOR = "Background Color"
export const COLOR_TRANSPARENT = "transparent"
export const COLOR_BLACK = "black"
export const COLOR_WHITE = "white"

export const DATA_FORMAT = "Data Format"
export const XLSX_DATA_FORMAT = "XLSX"
export const CSV_DATA_FORMAT = "CSV"

export const IMAGE_FORMAT = "Image Format"
export const PNG_FORMAT = "PNG"
export const JPEG_FORMAT = "JPEG"

export const ORIENTATION = "Orientation"
export const LANDSCAPE = "Landscape"
export const PORTRAIT = "Portrait"

export const EXPORT_PREFERENCE = "Export Preference"
export const SEPARATE_FILES = "Separate Files"
export const AS_SHOWN_ON_SCREEN = "As Shown on Screen"

export const exportChartOptions = [
  EXPORT_IMAGE,
  EXPORT_DATA,
  EXPORT_PDF,
  PRINT_CHART
]

export const backgroundColorOptions = [
  {
    label: capitalize(COLOR_TRANSPARENT),
    name: COLOR_TRANSPARENT,
    value: COLOR_TRANSPARENT
  },
  {
    label: capitalize(COLOR_WHITE),
    name: COLOR_WHITE,
    value: COLOR_WHITE
  },
  {
    label: capitalize(COLOR_BLACK),
    name: COLOR_BLACK,
    value: COLOR_BLACK
  }
]

export const orientationOptions = [
  {
    label: PORTRAIT,
    name: PORTRAIT,
    value: PORTRAIT,
    iconClassName: "icon-crop_portrait"
  },
  {
    label: LANDSCAPE,
    name: LANDSCAPE,
    value: LANDSCAPE,
    iconClassName: "icon-crop_landscape"
  }
]

export const dataFormatOptions = [
  {
    label: XLSX_DATA_FORMAT,
    name: XLSX_DATA_FORMAT,
    value: XLSX_DATA_FORMAT
  },
  {
    label: CSV_DATA_FORMAT,
    name: CSV_DATA_FORMAT,
    value: CSV_DATA_FORMAT
  }
]

export const preferenceOptions = [
  {
    label: SEPARATE_FILES,
    name: SEPARATE_FILES,
    value: SEPARATE_FILES
  },
  {
    label: AS_SHOWN_ON_SCREEN,
    name: AS_SHOWN_ON_SCREEN,
    value: AS_SHOWN_ON_SCREEN
  }
]
